import React, { Component } from 'react'
import '../estilospdf.css'

class Emailenviado extends Component {
  render () {
    return (
        <div className='emailenviado' >
           <h2>Gracias, su correo ha sido enviado me pondre en contacto a la brevedad posible</h2>
        </div>
    )
  }
}

export default Emailenviado